import React, { Component } from 'react';
import { connect } from 'react-redux';
import ApplyCSS from '../../../../../../components/ApplyCSS';
import { eventCategory } from '../../../../../../utils/clientConstant';
import commonUtil from '../../../../../../utils/commonUtil';

@connect(store => ({
  lables: store.labels.data,
}))

class Benefits extends Component {
  render() {
    const { lables } = this.props;
    const eventType = this.props.location.state;
    return (
      <React.Fragment>
        <ApplyCSS pageName="createEvent" />
        <div className="mainContainer giftBackground">
          <div className="container borderTop" id="createEvent">
            <div className="row">
              <div className="col-xs-12 col-md-10 col-md-offset-1">
                <div className="registerTitles">
                  <h2 className="registerGiftTitle"> {eventType === eventCategory.CELEBRATION ? commonUtil.getLabel(lables.selectMesaPage, 'selectMesaPage.celebration.name')
                  : commonUtil.getLabel(lables.selectMesaPage, 'selectMesaPage.open.name') }</h2>
                </div>
                {eventType === eventCategory.CELEBRATION ?
                  <div dangerouslySetInnerHTML={{ __html: commonUtil.getLabel(lables.selectMesaPage, 'selectMesaPage.celebrationEvent.benefits') }} />
                  :
                  <div dangerouslySetInnerHTML={{ __html: commonUtil.getLabel(lables.selectMesaPage, 'selectMesaPage.openEvent.benefits') }} />
                }
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default Benefits;
